<template>
  <div class="dashboard-container">
    <header>
      <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    </header>
    <!-- Asset Section -->    
     <div class="first-section">
      <div class="widget-company-logo">
        <img :src="companyLogo" alt="Company Logo" class="company-logo" />
        <!-- <img :src="whisky" alt="whiskyBottles" class="whisky"/> -->
      </div>
    </div>
    <div class="assets-container">
      <section class="assets-summary bordered-section">
        <h3 style="font-size: 30px;">Asset</h3>
        <div class="asset-cards" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;">
          <div class="card total-asset" @click="goToAssets('all')">
            <h4>Total Asset1</h4>
            <p style="display: flex; justify-content: space-between; align-items: center;">
              <span class="material-symbols-outlined" style="font-size: 48px;">inventory_2</span>
              <span style="font-size: 48px;">{{ totalAssets }}</span>
            </p>
          </div>
          <div class="card active-asset" @click="goToAssets('active')">
            <h4>Active Assets</h4>
            <p style="display: flex; justify-content: space-between; align-items: center;">
              <span class="material-symbols-outlined" style="font-size: 48px;">toggle_on</span>
              <span style="font-size: 48px;">{{ activeAssets }}</span>
            </p>
          </div>
          <div class="card inactive-asset" @click="goToAssets('inactive')">
            <h4>Inactive Assets</h4>
            <p style="display: flex; justify-content: space-between; align-items: center;">
              <span class="material-symbols-outlined" style="font-size: 48px;">toggle_off</span>
              <span style="font-size: 48px;">{{ inactiveAssets }}</span>
            </p>
          </div>
        </div>
      </section>
      <!-- Anomaly Assets Section -->
      <section class="anomaly-assets bordered-section">
        <h3 style="font-size: 30px;">Notification</h3>
        <div>
          <div class="card high-temp" @click="goToNotification()">
            <h4>warning</h4>
            <p style="display: flex; justify-content: space-between; align-items: center;">
              <span class="material-symbols-outlined" style="font-size: 48px;">notifications</span>
              <span style="font-size: 48px;">{{ notification }}</span>
            </p>
          </div>
        </div>
      </section>
    </div>
    <div class="feed-map-container">
          <!-- Event Feed Section -->
          <section class="events-feed bordered-section half-width">
            <h3 style="font-size: 30px;">Asset Chart</h3>
            <div class="chart-container">
              <canvas ref="pieChart"></canvas>

            </div>
          </section>
          <!-- Google Maps Iframe Section -->
          <iframe class="map-frame bordered-section half-width" src="https://www.google.com/maps/d/embed?mid=1FMOhkG2i6Wa8J0y0pdKC9W3SyFDLsNo" width="100%" height="480"></iframe>
      </div>
    
    
    <!-- 사이드바 추가 -->
    <EventTagSidebar
      v-if="isSidebarVisible"
      :visible="isSidebarVisible"
      :asset="selectedAsset"
      @close="closeSidebar"
    />
  </div>
</template>

<script>
import axios from 'axios';
import EventTagSidebar from '../components/EventTagSidebar.vue';
import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

export default {
  name: 'DashboardPage',
  components: {
    EventTagSidebar,
  },
  data() {
    return {
      companyLogo: require('@/assets/KAVALAN_LOGO.png'), 
      whisky: require('@/assets/kavalanbottles.png'),
      totalAssets: 0,
      activeAssets: 0,
      inactiveAssets: 0,
      highTempAssets: 0,
      lowTempAssets: 0,
      lowBatteryAssets: 0,
      events: [],
      selectedAsset: null,
      isSidebarVisible: false,
      autoRefreshInterval: null,
      notification:0,
    };
  },
  created() {
    this.loadDashboardData();
    this.refreshEventFeed(); // Load the event feed when the page is created
    this.checkNotification();
  },
  mounted() {
    // 2초마다 새로고침 설정
    this.autoRefreshInterval = setInterval(() => {
      this.loadDashboardData();
      this.refreshEventFeed();
      this.checkActiveStatus();
      this.checkNotification();
    }, 15000);
    this.renderChart();
  },
  beforeUnmount() {
    // 컴포넌트가 언마운트되기 전에 인터벌 해제
    clearInterval(this.autoRefreshInterval);
  },
  watch: {
    totalAssets: 'renderChart',
    activeAssets: 'renderChart',
    inactiveAssets: 'renderChart',
    highTempAssets: 'renderChart',
    lowTempAssets: 'renderChart',
    lowBatteryAssets: 'renderChart'
  },
  methods: {
    loadDashboardData() {
      axios.get('/api/dashboard').then((response) => {
        const data = response.data;
        this.totalAssets = data.totalAssets;
        this.activeAssets = data.activeAssets;
        this.inactiveAssets = data.inactiveAssets;
        this.highTempAssets = data.highTempAssets;
        this.lowTempAssets = data.lowTempAssets;
        this.lowBatteryAssets = data.lowBatteryAssets;
      })
      .catch((error) => {
        console.error('Failed to load dashboard data:', error);
      });
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.pieChart.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Active', 'Inactive'],
          datasets: [{
            data: [
              this.activeAssets,
              this.inactiveAssets,
            ],
            backgroundColor: [ '#4a90e2', '#50e3c2', ]
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '70%', // 가운데 비어있는 부분 크기 설정
          plugins: {
            legend: {
              position: 'left'
            },
            datalabels: {
              formatter: (value, context) => {
                const dataset = context.chart.data.datasets[0].data;
                const total = dataset.reduce((acc, val) => acc + val, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                return percentage + '%';
              },
              color: '#fff',
              font: {
                weight: 'bold'
              }
            }
          }
        }
      });
    },
    refreshEventFeed() {
      axios.get('/api/getEventFeed').then((response) => {
        // 최신순으로 정렬한 뒤, 상위 20개만 선택
        this.events = response.data
          .sort((a, b) => new Date(b.updatetime) - new Date(a.updatetime))
          .slice(0, 10);
      }).catch(error => {
        console.error('Failed to load event feed:', error);
      });
    },
    checkNotification(){
      axios.get('/api/getNotification').then((response)=>{
        const data = response.data;
        this.notification = data.notification;
        console.log(response.data);
      }).catch(error => {
        console.error('Failed to load notification:', error);
      });
    },
    checkActiveStatus() {
      axios.post('/api/checkactive').then((response) => {
        console.log('Active 상태가 업데이트되었습니다:', response.data.message);
      }).catch(error => {
        console.error('Failed to check active status:', error);
      });
    },
    goToNotification(){
      this.$router.push({ path: '/warningMap'});
    },
    goToAssets(filter) {
      this.$router.push({ path: '/assets', query: { filter } });
    },
    goToAnomalyAssets(filter) {
      this.$router.push({ path: '/assetList', query: { filter } });
      console.log("Navigating to assetList with filter:", filter);
    },
    openSidebar(tag_mac) {
      axios.get(`/api/getEventMac?tag_mac=${tag_mac}`).then(response => {
        this.selectedAsset = response.data; // 선택된 자산 정보 저장
        this.isSidebarVisible = true; // 사이드바 표시
      }).catch(error => {
        console.error('Failed to retrieve asset details:', error);
      });
    },
    closeSidebar() {
      this.isSidebarVisible = false; // 사이드바 숨김
      this.selectedAsset = null; // 선택된 자산 초기화
    },
    getStatusMessage(usercheck) {
      if (usercheck === 0) {
        return `slept `;
      } else if (usercheck === 2) {
        return `woken up `;
      }
      return '';
    },
    formatDateTime(dateTime) {
      const date = new Date(dateTime);
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      return date.toLocaleString('en-US', options);
    },
  },
};
</script>
<style scoped>
.dashboard-container {
  padding: 20px;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.first-section{
  display: flex;
  justify-content: center; /* 가운데 정렬 */
  align-items: center;
  width: 100%; /* 전체 너비 사용 */
}
.widget-company-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
  height: 400px;
  margin-right: 50px;
}
.company-logo {
  max-width: 70%;
  height: auto;
}

.assets-container {
  display: flex;
  gap: 10px;
  height: 350px; /* 원하는 고정 높이 */
}

.assets-summary {
  flex: 7;
  padding: 10px 20px;
  border: 2px solid #a8a8aa;
  border-radius: 10px;
  background-color: #fff;
}
.anomaly-assets {
  flex: 3;
  padding: 10px 20px;
  border: 2px solid #a8a8aa;
  border-radius: 10px;
  background-color: #fff;
}


.asset-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3개의 열을 만듭니다 */
  gap: 20px; /* 카드 간의 간격 */
}

.card {
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 10px;
}

.total-asset {
  background-color: #4e73df;
  color: white;
}

.active-asset {
  background-color: #1cc88a;
  color: white;
}

.inactive-asset {
  background-color: #36b9cc;
  color: white;
}

.high-temp {
  background-color: #c54f44;
  color: white;
}

.low-temp {
  background-color: #7895ec;
  color: white;
}

.low-battery {
  background-color: #ddbf5b;
  color: white;
}

.events-feed ul {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.events-feed li {
  background-color: #f8f9fc;
  border: 1px solid #e3e6f0;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.bordered-section {
  border: 2px solid #a8a8aa; /* 원하는 테두리 색상 */
  border-radius: 10px; /* 테두리 모서리 둥글게 */
  padding: 20px;
  margin-bottom: 10px; /* 섹션 사이에 간격 추가 */
  background-color: #fff; /* 배경색 추가 */
}

button {
  padding: 10px;
  background-color: #4e73df;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #2e59d9;
}


.sleep-message {
  color: green; /* 초록색 */
  font-weight: bold;
}

.woke-up-message {
  color: red; /* 빨간색 */
  font-weight: bold;
}
.devicename{
  color: rgb(238, 167, 36);
  font-weight: bold;
}
.feed-map-container {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.half-width {
  width: 50%;
}

.map-frame {
  border-radius: 10px;
}
.widget-notification-info{
  flex: 3;
  padding: 10px 20px;
  border: 2px solid #a8a8aa;
  border-radius: 10px;
  background-color: #fff;
  /* justify-content: left; */
  align-items: center;
  justify-content: center;
}
.notification-card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.notification-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ca1305;
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: left;
  width: 90%;
  cursor: pointer;
  position: relative;
  height: 110px;
}
.notification-icon {
  font-size: 40px;
}

.notification-info {
  text-align: right;
}

.notification-count {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
}
.notification-card-title {
  font-size: 18px;
  font-weight: bold;
  margin: 5px 0 0 0;
  color: #fff;
}
.notification-card-subtitle {
  font-size: 14px;
  color: #fff;
}
.view-details-button {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 16px;
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
  text-transform: uppercase;
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.view-details-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.widget-chart-2{
  display:flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
